module.exports = __webpack_public_path__ + "static/media/09tonghaojianxiugong.8fee039e.png";